module.exports = __webpack_public_path__ + "static/media/14UNEP7.b003d7b0.jpg";